/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shot_Change_AwareInputs */



/**
* | output |
* | --- |
* | "Shot Change Aware" |
*
* @param {Shot_Change_AwareInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shot_change_aware = /** @type {((inputs?: Shot_Change_AwareInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shot_Change_AwareInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Basé sur les changements de plan")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schusswechsel bewusst")
	if (locale === "it") return /** @type {LocalizedString} */ ("Consapevolezza del cambio di tiro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Shot Change Aware")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cambio de tiro consciente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("投篮变化感知")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ショットチェンジアウェア")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शॉट परिवर्तन के प्रति जागरूक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Consciente da troca de injeções")
	return /** @type {LocalizedString} */ ("Shot Change Aware")
});